import i18n from '@/libs/i18n'

export default [
  {
    id: 'campaign',
    title: i18n.t('layout.textCampaign'),
    route: 'campaign',
    icon: 'FolderIcon',
    tooltip: i18n.t('layout.textCampaign'),
  },
]
